import { FC } from 'react';

import styles from './styles.module.scss';

export const Separator: FC = () => <div className={styles.separator} />;
